export default "__VITE_ASSET__CPU5dvbn__"